define('fukit/behavior/type.ahead.search.behavior',['require','exports','module','underscore','marionette','uikit/uikit','uikit/extra/key.codes','backbone'],function(require, exports, module) {
  //prettier-ignore
  var _        = require('underscore'),
      Mn       = require('marionette'),
      UIKit    = require('uikit/uikit'),
      KeyCodes = require('uikit/extra/key.codes'),
      Backbone = require('backbone');

  var TypeAheadFindBehavior = Mn.Behavior.extend({
    defaults: {
      // An array of attributes to search on.  All fields will search the
      // value being entered into the input element. At least one search field
      // must be configured or bevavior defaults to a typical input element.
      //
      // Example: ['field1', 'field2', 'field3']
      //
      // NOTE: Cayuse services traditional API currently returns meaningful results for only one query field
      queryFields: [],

      // An object of paramName/paramValue pairs that will translated into query parameter filter flags for
      // Search Service requests
      //
      // Example { paramName: paramValue }
      //
      // becomes "&paramName=paramValue" in the request URL
      additionalSearchServiceParams: {},

      // Function that allows custom logic to be passed in from the parent view
      // Useful for when extra other logic other than harvesting the bound field from
      // the resultsView is necessary.
      onResultSelected: null,

      // If true, will allow the user to enter text not supplied by the autocomplete
      // results, otherwise, user must choose a result
      allowFreeText: false,

      // Collection of type BaseCollection used to manage type ahead find results.  An autocompleteCollection
      // An autocompleteCollection must be configured or bevavior defaults to a typical
      // input element.
      autocompleteCollection: null,

      // Binding for autocomplete collection to the results view.
      autocompleteDropdownBindings: {
        text: 'name',
      },

      // Search wildcard prefixes that can be altered to return items that start with or
      // end with the passed search value
      wildcardPrefix: '*',
      wildcardSuffix: '*',

      // Sometimes having inactive records returned for autocomplete suggestions is not desired.
      // Setting this flag to true will filter out inactive results
      excludeInactives: false,

      // Allow option to use static search collection
      // If this option is enabled, then there are a few other options/parameters that you can use to handle type ahead search
      //  - Options
      //    - initializeStaticSearchFromParentModelAttribute: the attribute of your parentModel to initialize the type ahead search with
      //  - Parameters on the Input component
      //    - bindings.value: the value that is bound to your query
      //    - model: the model that is bound to your query
      //    - parentModel: the model that is bound to your form
      useStaticCollection: false,

      // Allow option to use a custom search results view.  Default is UIKit.SearchResults
      searchResultsView: UIKit.SearchResults,
    },

    hasBeenSelected: false,

    isTyping: false,

    initialize: function() {
      var searchResultsView = this.getOption('searchResultsView');

      Mn.Behavior.prototype.initialize.apply(this, arguments);
      this.queryFields = this.getOption('queryFields');
      this.autocompleteCollection = this.getOption('autocompleteCollection');

      //if no search fields or an autocomplete collection have been configured, default to normal input element behavior
      if (_.isEmpty(this.queryFields) || _.isNull(this.autocompleteCollection)) {
        return;
      }

      this.parentChildAttributeMapping = this.getOption('parentChildAttributeMapping');
      this.view.resultsView = new searchResultsView();

      this.listenToOnce(this.view, 'typeahead:key:down', this.initializeOriginalValue)
        .listenTo(this.view, 'typeahead:change:value', this.handleChangeValue)
        .listenTo(this.view, 'typeahead:blur', this.handleBlur)
        .listenTo(this.view, 'typeahead:key:down', this.handleKeydown)
        .listenTo(this.view.resultsView, 'result:selected', this.onItemSelected)
        .listenTo(this.view, 'first:before:render', this.handleBeforeFirstRender);
    },

    initializeOriginalValue: function() {
      this.originalValue = this.view.value;
    },

    handleBeforeFirstRender: function() {
      if (this.getOption('useStaticCollection') !== true) {
        return;
      }
      if (!(this.getOption('staticCollection') instanceof Backbone.Collection)) {
        return console.error(new Error('Option staticCollection must be a collection if useStaticCollection is true.'));
      }

      //prettier-ignore
      var parentModel = this.view.parentModel,
          bindings = this.view.bindings,
          parentModelAttribute = this.getOption('initializeStaticSearchFromParentModelAttribute');
      if (_.has(bindings, 'value') && _.isString(parentModelAttribute) && parentModel instanceof Backbone.Model) {
        this.originalValue = parentModel.get(parentModelAttribute);
        this.view.model.set(bindings.value, this.originalValue);
      }
    },

    handleChangeValue: function(inputValue, previousValue) {
      if (this.hasBeenSelected) {
        this.hasBeenSelected = false;
        return;
      }
      if (!inputValue) {
        return;
      }

      if (this.isTyping) {
        this.onChangeSearchValue(inputValue);
      }
    },

    handleBlur: function() {
      var allowFreeText = this.getOption('allowFreeText');

      if (!_.isEmpty(this.view.model.changed)) {
        if (allowFreeText) {
          this.setInputValue(this.view.value);
          return;
        } else {
          var resetValue = this.view.value ? this.originalValue : this.getEmptyValue();
          this.hasBeenSelected = true;
          this.setInputValue(resetValue);
        }
      }
      this.clearSuggestions();
    },

    handleKeydown: function(keycode) {
      var resultsView = this.view.resultsView;

      this.isTyping = true;

      if (keycode === KeyCodes.DOWNARROW_KEY) {
        resultsView.selectNextResult();
      } else if (keycode === KeyCodes.UPARROW_KEY) {
        resultsView.selectPreviousResult();
      } else if (!resultsView.empty && (keycode === KeyCodes.ENTER_KEY || keycode === KeyCodes.TAB_KEY)) {
        selected = resultsView.getSelected();
        this.onItemSelected(selected);
      } else if (keycode === KeyCodes.ESCAPE_KEY) {
        this.setInputValue(this.view.value);
        this.clearSuggestions();
      }
    },

    onItemSelected: function(result) {
      //prettier-ignore
      var valueAttribute = this.getOption('autocompleteDropdownBindings').text,
          onResultSelected = this.getOption('onResultSelected');

      this.hasBeenSelected = true;
      this.view.resultsView.collection.reset();

      if (onResultSelected) {
        onResultSelected(result, this);
      }
      this.setInputValue(result.model.get(valueAttribute));

      this.view.trigger('typeahead:item:selected', this.view, result);
    },

    onChangeSearchValue: function(value) {
      //prettier-ignore
      var collection,
        autocompleteDropdownBindings,
        fields = this.queryFields;

      if ((_.isNull(value) || value.length === 0) && this.parentChildAttributeMapping) {
        this.view.model.set(this.parentChildAttributeMapping.parentAttribute, this.getEmptyValue());
        return;
      }

      collection = this.getAutocompleteCollection(value, fields);
      autocompleteDropdownBindings = this.getOption('autocompleteDropdownBindings');
      this.setAutocompleteDropdownViewCollection(collection, autocompleteDropdownBindings);
    },

    getEmptyValue: function() {
      return this.view.getOption('saveEmptyStringAsNull') ? null : '';
    },

    setInputValue: function(value) {
      if (value) {
        this.hasBeenSelected = true;
        this.isTyping = false;
      }
      this.originalValue = value;
      this.view.ui.input.val(value);
      this.view.value = value;

      this.view.trigger('typeahead:input:value', this.view, value);
    },

    getStaticCollectionResults: function(autocompleteCollection, value, fields) {
      var staticCollection = this.getOption('staticCollection');

      if (!(staticCollection instanceof Backbone.Collection)) {
        return autocompleteCollection;
      }
      function cleanString(string) {
        return string.replace(/[ ,]/g, '').toLowerCase();
      }
      var results = _.filter(staticCollection.models, function(model) {
        return _.some(fields, function(field) {
          return cleanString(model.get(field)).match(new RegExp(cleanString(value)));
        });
      });
      autocompleteCollection.reset();

      return autocompleteCollection.add(results);
    },

    setTraditionalAPIFilters: function(autocompleteCollection, value, fields) {
      //prettier-ignore
      var fieldName        = this.getOption('autocompleteDropdownBindings').text,
          wildcardPrefix   = this.getOption('wildcardPrefix'),
          wildcardSuffix   = this.getOption('wildcardSuffix'),
          excludeInactives = this.getOption('excludeInactives');

      if (!this.autocompleteFilter) {
        this.autocompleteFilter = autocompleteCollection.filters;
        _.each(
          fields,
          function(name) {
            this.autocompleteFilter.add(this.createFilterObject(value, name, wildcardPrefix, wildcardSuffix));
          },
          this
        );
      } else {
        _.each(
          fields,
          function(name) {
            this.autocompleteFilter.setValueByName(name, wildcardPrefix + value + wildcardSuffix);
          },
          this
        );
      }

      if (excludeInactives) {
        this.autocompleteFilter.add({ field: 'active', value: true });
      }

      autocompleteCollection.sort.field(fieldName).makeAscending();

      return autocompleteCollection;
    },

    setSearchServiceFilters: function(value, queryFields, additionalSearchServiceParams) {
      this.autocompleteCollection.filters.set({
        query: value,
        queryFields: queryFields,
        additionalParams: additionalSearchServiceParams,
      });
    },

    setAutocompleteCollectionFilters: function(value, fields) {
      //prettier-ignore
      var useStaticCollection           = this.getOption('useStaticCollection'),
          useSearchServiceAPI           = this.autocompleteCollection.filters.isSearchServiceFilter,
          fieldName                     = this.getOption('autocompleteDropdownBindings').text,
          queryFields                   = this.getOption('queryFields'),
          additionalSearchServiceParams = this.getOption('additionalSearchServiceParams');

      // Retrieve results collection from static collection
      if (useStaticCollection === true) {
        return this.getStaticCollectionResults(this.autocompleteCollection, value, fields);

        // Initialize seach service API criteria
      } else if (useSearchServiceAPI === true) {
        this.setSearchServiceFilters(value, queryFields, additionalSearchServiceParams);

        //TODO: re-implement sort when search service supports it.
        this.autocompleteCollection.sort.field(queryFields.join(',')).makeAscending();
        this.autocompleteCollection.fetch();

        return this.autocompleteCollection;

        // Initialize traditional search API criteria
      } else {
        this.setTraditionalAPIFilters(this.autocompleteCollection, value, fields);
        this.autocompleteCollection.sort.field(fieldName).makeAscending();
        this.autocompleteCollection.fetch();

        return this.autocompleteCollection;
      }
    },

    getAutocompleteCollection: function(value, fields) {
      this.setAutocompleteCollectionFilters(value, fields);

      return this.autocompleteCollection;
    },

    createFilterObject: function(value, field, wildcardPrefix, wildcardSuffix) {
      return {
        field: field,
        value: wildcardPrefix + value + wildcardSuffix,
      };
    },

    setAutocompleteDropdownViewCollection: function(collection, bindings) {
      this.view.resultsView.childBindings = bindings;
      this.view.resultsView.collection = collection;
    },

    clearSuggestions: function() {
      if (!this.view.resultsView.empty) {
        this.view.resultsView.collection.reset();
      }
    },
  });
  module.exports = TypeAheadFindBehavior;
});

